import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-lysing-list',
  templateUrl: './lysing-list.component.html',
  styleUrls: ['./lysing-list.component.css']
})
export class LysingListComponent {

  @ViewChild('dt') dt: Table | undefined;

  lysinglist: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
    const filters = localStorage.getItem("filters");

    this.dataService.getLysingList().then(data => {
      this.lysinglist = data;
      this.loading = false;
    });

    this.cols = [
      { field: 'lysingInstrument', header: 'Lysing Instrument' },
      { field: 'neutralizationInstrument', header: 'Neutralization Instrument' },
      { field: 'wells', header: 'Wells' },
      { field: 'lysingDate', header: 'Lysing Date' },
      { field: 'ovenStartDate', header: 'Oven Start Date' },
      { field: 'ovenEndDate', header: 'Oven End Date' },
      { field: 'neutralizationDate', header: 'Neutralization Date' },
      { field: 'lysingIncident', header: 'Last Lysing Incident' },
      { field: 'lysingIncidentDate', header: 'Last Lysing Incident Date' },
      { field: 'neutralizationIncident', header: 'Last Neutralization Incident' },
      { field: 'neutralizationIncidentDate', header: 'Last Neutralization Incident Date' },
      { field: 'lysingService', header: 'Last Lysing Service' },
      { field: 'lysingServiceDate', header: 'Last Lysing Service Date' },
      { field: 'neutralizationService', header: 'Last Neutralization Service' },
      { field: 'neutralizationServiceDate', header: 'Last Neutralization Service Date' }
    ];
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any, stringVal:any) {
    this.dt?.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  rowClick(ecord: any){
    //this.router.navigate(['detail',snpRecord.sampleId]);
  }
}
